export default __webpack_public_path__ + "static/media/hbs-k-blk-poster-1.442de8bb.jpg";